import {CanvasRenderer} from "./components/CanvasRenderer";
import {getCookie, setCookie} from "./utils/CookieUtils";

class Main {
    canvasRender: CanvasRenderer;
    constructor() {
        console.log('Main 2');
        if (window.location.hash === '#accepted' || getCookie('accepted') === 'true') {
            document.querySelector('.AcceptUI').remove();

        } else {
            document.querySelector('.AcceptUI-inner button').addEventListener('click', () => {
                document.documentElement.classList.add('accepted');
                setCookie('accepted', 'true', 300000);
                setTimeout(() => {
                    document.querySelector('.AcceptUI').remove();
                }, 250)
            });
        }
        this.canvasRender = new CanvasRenderer();
        this.resize();
        window.addEventListener('resize', this.resize);


    }

    resize = () => {
    }
}

window.onload = () => {
    // @ts-ignore

    window.Main = new Main();
};
